/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Entityachievementsdescription2Inputs */

const id_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data kemajuan`)
};

const ms_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data kemajuan`)
};

const da_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremskridtsdata`)
};

const de_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fortschrittsdaten`)
};

const en_us2_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progression data`)
};

const es_es2_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de progresión`)
};

const es_mx2_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datos de progresión`)
};

const fil_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data ng progreso`)
};

const fr_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Données de progression`)
};

const it_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dati di progressione`)
};

const hu_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Előrehaladási adatok`)
};

const nl_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voortgangsgegevens`)
};

const no_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fremdriftsdata`)
};

const pl_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dane progresji`)
};

const pt_br2_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de progressão`)
};

const pt_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dados de progressão`)
};

const ro_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Date de progresie`)
};

const fi_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edistymistiedot`)
};

const sv_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Framstegsdata`)
};

const vi_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dữ liệu tiến trình`)
};

const tr_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İlerleme verileri`)
};

const cs_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Data o postupu`)
};

const bg_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данни за напредък`)
};

const ru_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Данные прогресса`)
};

const uk_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дані прогресу`)
};

const ar_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بيانات التقدم`)
};

const hi_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रगति डेटा`)
};

const th_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ข้อมูลความคืบหน้า`)
};

const ja_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進行データ`)
};

const zh_cn2_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`进度数据`)
};

const zh_hant1_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`進度資料`)
};

const ko_sandboxes_entityachievementsdescription2 = /** @type {(inputs: Sandboxes_Entityachievementsdescription2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`진행 데이터`)
};

/**
* | output |
* | --- |
* | "Progression data" |
*
* @param {Sandboxes_Entityachievementsdescription2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_entityachievementsdescription2 = /** @type {((inputs?: Sandboxes_Entityachievementsdescription2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Entityachievementsdescription2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "ms") return ms_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "da") return da_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "de") return de_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "fil") return fil_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "fr") return fr_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "it") return it_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "hu") return hu_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "nl") return nl_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "no") return no_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "pl") return pl_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "pt") return pt_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "ro") return ro_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "fi") return fi_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "sv") return sv_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "vi") return vi_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "tr") return tr_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "cs") return cs_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "bg") return bg_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "ru") return ru_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "uk") return uk_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "ar") return ar_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "hi") return hi_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "th") return th_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "ja") return ja_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_entityachievementsdescription2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_entityachievementsdescription2(inputs)
	return ko_sandboxes_entityachievementsdescription2(inputs)
});
export { sandboxes_entityachievementsdescription2 as "sandboxes.entityAchievementsDescription" }